/**
 * sco design system — font family tokens.
 * Source of truth. Edit directly.
 *
 * Nebula Sans is used when NEXT_PUBLIC_NEW_FONTS is 1/true/yes/on.
 * `brand` stays Poppins so surfaces that opt into it (e.g. GenericHero) keep the old heading look.
 */

import { defineTokens } from '@chakra-ui/react'
import { USE_NEW_FONTS } from '../new-fonts'

const poppins = 'Poppins, Helvetica, Arial, sans-serif'
const lato = 'Lato, Helvetica, Arial, sans-serif'
const nebula = 'Nebula Sans, sans-serif'
const nebulaMono = 'Nebula Sans, monospace'

export const fonts = defineTokens.fonts({
  heading: {
    value: USE_NEW_FONTS ? nebulaMono : poppins,
  },
  brand: {
    value: poppins,
  },
  mono: {
    value: USE_NEW_FONTS ? nebulaMono : 'Monaco, monospace',
  },
  body: {
    value: USE_NEW_FONTS ? nebula : poppins,
  },
  longform: {
    value: USE_NEW_FONTS ? nebula : lato,
  },
})
